export const BLOC_CLIENTS_VALIDATION_RULES = {
  name: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/clients/blocClientsValidationRules.js